<div
  class="relative pr-xxsmall-x nordic-blue-50-bg border-bottom"
  data-testid="histogram"
  #histogramContainer
  role="presentation"
>
  <fin-scroll-handle-container
    #scrollContainer
    [elements]="bars"
    class="nordic-blue-50-bg flex flex--center"
    (scrollElements)="barsScrolled.emit($event)"
    [disableKeyboardNavigation]="true"
  >
    <div class="flex flex--column-row flex--align-end ps-medium-t bar-container">
      <ng-container *ngFor="let bar of range$ | async; let i = index">
        <ng-container *ngIf="bar?.spacer">
          <ng-container *ngTemplateOutlet="verticalSeparator; context: { label: bar?.spacer?.value }" />
        </ng-container>

        <div
          class="flex flex--column flex--end link-hover border-top border-left border-right rounded-top-medium bar"
          [attr.data-testid]="'histogram-bar-' + i"
          [class.cheapest]="bar?.isCheapest"
          [class.noFlight]="bar.noFlight"
          [class.selected]="(selected$ | async) === i && (isLoading$ | async) === false"
          [class.loading]="isLoading$ | async"
          [class.grey-25-bg]="isLoading$ | async"
          #bar
          [style.height]="bar.height"
          (click)="scrollToBarByIndex(bar)"
        >
          <p class="text-align center font-body-2" data-testid="histogram-label">{{ bar.text }}</p>
          @if (isLoading$ | async) {
            <span class="grey-bar center"></span>
          }
          <p *ngIf="!bar.noFlight" class="text-align center font-body-2 medium-type" data-testid="histogram-price">
            {{
              { amount: bar.amount, currencyCode: bar.currencyCode }
                | finPrice: { abbreviate: true, useCustomFormat: true }
            }}
          </p>
          <fcom-icon
            *ngIf="bar.noFlight"
            class="center icon-small ms-xxsmall-b"
            [name]="SvgLibraryIcon.FLIGHTS_UNAVAILABLE"
          />
        </div>
      </ng-container>
    </div>
  </fin-scroll-handle-container>
</div>

<ng-template #verticalSeparator let-label="label">
  <div class="flex flex--center flex--column flex--self-stretch" data-testid="histogram-spacer">
    <p class="font-body-2" data-testid="histogram-spacer-label">{{ label }}</p>
    <div class="border-left grow" [ngStyle]="CMS_STYLE_OVERRIDE"></div>
  </div>
</ng-template>
